export default __webpack_public_path__ + "static/media/telegram.8544ffd4.png";